export type BearriMotionName =
  | 'search'
  | 'idle'
  | 'celebrate'
  | 'wave'
  | 'sleeping'
  | 'thinking'
  | 'reading'
  | 'loving'
  | 'writing'
  | 'mail'
  | 'contract'
  | 'berry'
  | 'scout';

export type BearriMotionAsset = {
  webm: string;
  hevc: string;
  animatedFallback: string;
  poster: string;
  ratio: number;
};

/**
 * One manifest for every rendered mascot clip. Keeping the formats together
 * prevents a page from pairing a clip with the wrong poster or aspect ratio.
 */
export const BEARRI_MOTION: Record<BearriMotionName, BearriMotionAsset> = {
  search: {
    webm: '/motion/bearri-search.webm',
    hevc: '/motion/bearri-search.mp4',
    animatedFallback: '/motion/bearri-search.animated.webp',
    poster: '/motion/bearri-search.png',
    ratio: 500 / 360,
  },
  idle: {
    webm: '/motion/bearri-idle.webm',
    hevc: '/motion/bearri-idle.mp4',
    animatedFallback: '/motion/bearri-idle.animated.webp',
    poster: '/motion/bearri-idle.png',
    ratio: 292 / 400,
  },
  celebrate: {
    webm: '/motion/bearri-celebrate.webm',
    hevc: '/motion/bearri-celebrate.mp4',
    animatedFallback: '/motion/bearri-celebrate.animated.webp',
    poster: '/motion/bearri-celebrate.png',
    ratio: 338 / 400,
  },
  wave: {
    webm: '/motion/bearri-wave.webm',
    hevc: '/motion/bearri-wave.mp4',
    animatedFallback: '/motion/bearri-wave.animated.webp',
    poster: '/motion/bearri-wave.png',
    ratio: 377 / 400,
  },
  sleeping: {
    webm: '/motion/bearri-sleeping.webm',
    hevc: '/motion/bearri-sleeping.mp4',
    animatedFallback: '/motion/bearri-sleeping.animated.webp',
    poster: '/motion/bearri-sleeping.png',
    ratio: 1536 / 1024,
  },
  thinking: {
    webm: '/motion/bearri-thinking.webm',
    hevc: '/motion/bearri-thinking.mp4',
    animatedFallback: '/motion/bearri-thinking.animated.webp',
    poster: '/motion/bearri-thinking.png',
    ratio: 1,
  },
  reading: {
    webm: '/motion/bearri-reading.webm',
    hevc: '/motion/bearri-reading.mp4',
    animatedFallback: '/motion/bearri-reading.animated.webp',
    poster: '/motion/bearri-reading.png',
    ratio: 1,
  },
  loving: {
    webm: '/motion/bearri-loving.webm',
    hevc: '/motion/bearri-loving.mp4',
    animatedFallback: '/motion/bearri-loving.animated.webp',
    poster: '/motion/bearri-loving.png',
    ratio: 1,
  },
  writing: {
    webm: '/motion/bearri-writing.webm',
    hevc: '/motion/bearri-writing.mp4',
    animatedFallback: '/motion/bearri-writing.animated.webp',
    poster: '/motion/bearri-writing.png',
    ratio: 400 / 378,
  },
  mail: {
    webm: '/motion/bearri-mail.webm',
    hevc: '/motion/bearri-mail.mp4',
    animatedFallback: '/motion/bearri-mail.animated.webp',
    poster: '/motion/bearri-mail.png',
    ratio: 360 / 400,
  },
  contract: {
    webm: '/motion/bearri-contract.webm',
    hevc: '/motion/bearri-contract.mp4',
    animatedFallback: '/motion/bearri-contract.animated.webp',
    poster: '/motion/bearri-contract.png',
    ratio: 360 / 400,
  },
  berry: {
    webm: '/motion/bearri-berry.webm',
    hevc: '/motion/bearri-berry.mp4',
    animatedFallback: '/motion/bearri-berry.animated.webp',
    poster: '/motion/bearri-berry.png',
    ratio: 400 / 366,
  },
  scout: {
    webm: '/motion/bearri-scout.webm',
    hevc: '/motion/bearri-scout.mp4',
    animatedFallback: '/motion/bearri-scout.animated.webp',
    poster: '/motion/bearri-scout.png',
    ratio: 366 / 400,
  },
};
